<template>
    <v-container fluid pa-0>
        <v-card elevation="0">
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{$t(this.$route.meta.title)}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-btn-refresh
                            @invoke-method="dbGetLanguages(true)"
                        ></bc-btn-refresh>
                    </v-toolbar>
                </v-layout>
            </v-container>
            <v-flex px-4 mt-4>
                <v-layout row wrap>
                    <v-flex xs12 v-if="hasPerm('configuration.update')">
                        <bc-autocomplete
                            :focus="true"
                            v-model="language"
                            :label="$t('lang.edit_language')"
                            :items="available_languages"
                            item-text="language"
                            item-value="language"
                            return-object
                        ></bc-autocomplete>
                    </v-flex>
                    <v-flex xs12 v-if="language.language != null && language.status == 0">
                        <div>
                            <v-layout row>
                                <v-flex my-auto>
                                    <h4 class="mb-0">{{ language.language }} ({{language.iso}})</h4>
                                </v-flex>
                                <v-divider class="mx-0 ml-3 mr-3" vertical></v-divider>
                                <div class="ml-auto my-auto" style="min-width: 70px;">
                                    <v-chip disabled class="ma-0 w-100 flex-column" dark :color="language.status == 1 ? 'success' : 'error'">{{ language.status == 1 ? $t('lang.active') : $t('lang.inactive') }}</v-chip>
                                </div>
                                <v-flex ml-auto style="width: 100px;" v-if="hasPerm('configuration.update')">
                                    <v-btn flat v-if="language.status == 0" color="success" @mouseup.left="activateLanguage(1, language.language_id)">{{$t('lang.activate')}}</v-btn>
                                    <v-btn flat v-if="language.status == 1" color="error" @mouseup.left="activateLanguage(0, language.language_id)">{{$t('lang.deactivate')}}</v-btn>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-flex>
                    <v-flex xs12 v-if="language.language == null && current_languages.length == 0">
                        <div style="text-align: center">{{$t('lang.language_properties')}}</div>
                    </v-flex>
                    <v-flex my-2 v-else>
                        <h1>{{$t('lang.active_languages')}}</h1>
                        <v-divider></v-divider>
                    </v-flex>
                    <v-flex xs12 v-for="(lang, index) in current_languages" :key="index">
                        <div>
                            <v-layout row>
                                <v-flex my-auto>
                                    <h4 class="mb-0">{{ lang.language }} ({{lang.iso}})</h4>
                                </v-flex>
                                <v-divider class="mx-0 ml-3 mr-3" vertical></v-divider>
                                <div class="ml-auto my-auto" style="min-width: 70px;">
                                    <v-chip disabled class="ma-0 w-100 flex-column" dark :color="lang.status == 1 ? 'success' : 'error'">{{ lang.status == 1 ? $t('lang.active') : $t('lang.inactive') }}</v-chip>
                                </div>
                                <v-flex ml-auto  style="width: 100px;" v-if="hasPerm('configuration.update')">
                                    <v-btn flat v-if="lang.status == 0" color="success" @mouseup.left="activateLanguage(1, lang.language_id)">{{$t('lang.activate')}}</v-btn>
                                    <v-btn flat v-if="lang.status == 1" color="error" @mouseup.left="activateLanguage(0, lang.language_id)">{{$t('lang.deactivate')}}</v-btn>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import app from "Main";

export default {
    data() {
        return {
            language: {},
            dbGetLanguages: _.debounce(this.getLanguages, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        if (store.getters.user_is_dev) {
            store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        next((vm) => {
                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            app.createAlert();
            next({ name: "dashboard", replace: true });
        }
    },
    beforeRouteUpdate(to, from, next) {
        if (store.getters.user_is_dev) {
            this.$store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data != "undefined") {
                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "dashboard", replace: true });
                    }
                });
        } else {
            this.createAlert();
            next({ name: "dashboard", replace: true });
        }
    },
    computed: {
        ...mapState({
            all_languages: (state) => state.languages.all_languages,
        }),
        current_languages() {
            let current = [];
            if ((this.all_languages || []).length > 0) {
                current = this.all_languages.filter((language) => {
                    return language.status == 1;
                });
            }
            return current;
        },
        available_languages() {
            let available = [];
            if ((this.all_languages || []).length > 0) {
                available = this.all_languages.filter((language) => {
                    return language.status == 0;
                });
            }
            return available;
        },
    },
    methods: {
        getLanguages(refresh = false) {
            if (refresh) this.startLoader();
            this.$store
                .dispatch("fetchLanguages", {
                    url: "languages",
                    method: "get",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    commit: true,
                })
                .then((data) => {
                    if (refresh) this.finishLoader(refresh);
                });
        },
        activateLanguage(status, id) {
            this.startLoader();
            let updatedLang = {
                status: status,
            };
            this.$store
                .dispatch("fetchLanguages", {
                    pk: "language_id",
                    id: id,
                    url: "languages/" + id,
                    method: "patch",
                    stateProperty: "all_languages",
                    dataProperty: "languages",
                    mutate: true,
                    body: updatedLang,
                })
                .then(() => {
                    if (status) this.language = {};
                    this.finishLoader();
                });
        },
    },
};
</script>
